import React from "react";
import "../../App.scss";

class SignOut extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    localStorage.removeItem("x-ozsk-auth-token");
    setTimeout(() => {
      window.location.assign("/portal-giris");
    }, 700);
  }

  componentDidMount() {
    this.signOut();
  }

  render() {
    return <div className="zero-div"></div>;
  }
}

export default SignOut;
